import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const AboutContainer = styled(motion.div)`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const About = () => {
  return (
    <AboutContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h1>병원 소개</h1>
      <p>서울 주니어 치과는 어린이 전문 치과입니다.</p>
      <p>최신 장비와 전문 의료진이 함께합니다.</p>
    </AboutContainer>
  );
};

export default About; 